import { Injectable } from '@angular/core';
import { CanActivate, CanLoad } from '@angular/router';
import { ActivatedRouteSnapshot, Route, Router } from '@angular/router';
import { AuthService } from './auth.service';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate {

  constructor(private router: Router, private authService: AuthService) { }
    async canActivate(route: ActivatedRouteSnapshot): Promise<any> {
        const token = await this.authService.gettoken();
        if (!token) {
            this.router.navigate(['/login']);
            return false;
        }
        
        return true;
    }
    
}
